var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_18552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48997 4.30677C8.0707 3.73111 8.87896 3.37462 9.77188 3.37462C10.9624 3.37462 11.9943 4.00445 12.5499 4.9429C13.043 4.73296 13.5772 4.62457 14.1174 4.62483C16.2605 4.62483 18 6.29388 18 8.35342C18 10.413 16.2605 12.082 14.1174 12.082C13.8555 12.082 13.6002 12.0569 13.3502 12.0096C12.864 12.8346 11.9347 13.3952 10.8765 13.3952C10.4456 13.396 10.0203 13.3029 9.63298 13.1231C9.14022 14.2253 7.99265 15 6.65657 15C5.26097 15 4.07702 14.1623 3.62064 12.9845C3.41751 13.0254 3.21047 13.0459 3.00287 13.0458C1.34269 13.0458 0 11.7483 0 10.1549C0 9.08415 0.604542 8.152 1.50143 7.64814C1.31116 7.23075 1.21322 6.78051 1.21371 6.3255C1.21371 4.4864 2.78129 3 4.71265 3C5.84368 3 6.85566 3.51331 7.49063 4.31004",
    fill: "#00A1E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_18552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce);
export default __webpack_public_path__ + "static/media/salesforce.bc010593c1125367fed3d03d9f00a198.svg";
export { ForwardRef as ReactComponent };